import ImportError from './importError'

const ImportErrors = ({ errors }) => {
  return (
    <div>
      {errors.map((error, index) => (
        <ImportError key={index} error={error} />
      ))}
    </div>
  )
}

export default ImportErrors
